import { BatchModel } from './BatchModel';
import { SourceBatchDto } from './SourceBatchDto';

export interface SourceBatchModel {
    categoriesId: number[],
    sources: BatchModel[],
    sourcesDto: SourceBatchDto[]
}

export const sourceBatchModelInitial: SourceBatchModel = {
    categoriesId: [],
    sources: [],
    sourcesDto: []
};